module.exports = __webpack_public_path__ + "media/images/thumbs/biology/v_qv_meiosis_ii_17-a81752ea964a28b17fc6430e23546dd1.jpg";